module.exports = __webpack_public_path__ + "static/media/underwritterStep.a9b87dc9.svg";